import * as types from '../mutation-types'
import router from '../../router'
import UserApi from '../../api/user'

const getDefaultState = () => {
  return {
    loginFailed: false,
    forgotPasswordFailed: false,
    resetPasswordAccessGranted: false,
    resetPasswordFailed: false,
    logged: false,
    main: {
      username: null,
      token: null,
      id: null,
      name: null,
      initial: null
    }
  }
}

const state = getDefaultState()

export const getters = {
  isLogged: state => state.logged
}

export const actions = {
  login ({ dispatch, commit }, { username, password }) {
    UserApi.loginCheck(username, password)
      .then(response => {
        let data = response.data

        commit(types.USER.LOGIN.SUCCESSFUL, {
          username: username,
          token: data.token,
          id: data.user.id,
          name: data.user.name,
          initial: data.user.initial
        })

        dispatch('lawFirms/initLawFirms', data.user.lawFirms, { root: true })

        router.push({ name: 'home' })
      }).catch((e) => {
        commit(types.USER.LOGIN.FAILED)
      })
  },
  logout ({ dispatch, commit }, { noRedirect, query }) {
    commit(types.USER.RESET)

    if (!noRedirect) {
      let params = {}

      if (query !== undefined) {
        params = query
      }

      router.push({ name: 'login', query: params })
    }

    dispatch('drive/reset', null, { root: true })
  },
  forgotPassword ({ commit }, { username, lawFirmId }) {
    commit(types.USER.PASSWORD.FORGOT.RESET)

    UserApi.forgotPassword(username)
      .then(() => {
        let params = {}

        if (lawFirmId !== undefined) {
          params.law_firm_id = lawFirmId
        }

        router.push({ name: 'password-forgot-confirmation', query: params })
      }).catch(() => {
        commit(types.USER.PASSWORD.FORGOT.FAILED)
      })
  },
  checkAuthorizationResetPassword ({ commit }, { id, token }) {
    UserApi.checkAuthorizationResetPassword(id, token)
      .then(() => {
        commit(types.USER.PASSWORD.RESET.ACCESS_GRANTED)
      })
      .catch(() => {
        router.push({ name: 'login', query: { law_firm_id: router.app.$route.query.law_firm_id } })
      })
  },
  resetPassword ({ commit }, { id, token, lawFirmId, password, isFirstReset }) {
    UserApi.resetPassword(id, token, password, isFirstReset)
      .then(() => {
        let params = {}

        if (lawFirmId !== undefined) {
          params.law_firm_id = lawFirmId
        }

        router.push({ name: 'password-reset-confirmation', query: params })
      })
      .catch(() => {
        commit(types.USER.PASSWORD.RESET.FAILED)
      })
  }
}

export const mutations = {
  [types.USER.LOGIN.FAILED] (state) {
    state.loginFailed = true
  },
  [types.USER.LOGIN.SUCCESSFUL] (state, { username, token, id, name, initial }) {
    state.loginFailed = false
    state.logged = true
    state.main.username = username
    state.main.token = token
    state.main.id = id
    state.main.name = name
    state.main.initial = initial
  },
  [types.USER.PASSWORD.FORGOT.FAILED] (state) {
    state.forgotPasswordFailed = true
  },
  [types.USER.PASSWORD.FORGOT.RESET] (state) {
    state.forgotPasswordFailed = false
  },
  [types.USER.PASSWORD.RESET.ACCESS_GRANTED] (state) {
    state.resetPasswordAccessGranted = true
  },
  [types.USER.PASSWORD.RESET.FAILED] (state) {
    state.resetPasswordFailed = true
  },
  [types.USER.RESET] (state) {
    Object.assign(state, getDefaultState())
  }
}

// noinspection JSUnusedGlobalSymbols
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
